import { Extension } from "@tiptap/core";

export type VerticalAlignment = "top" | "middle" | "bottom";

export const VerticalAlignmentExtension = Extension.create({
  name: "verticalAlignment",

  addGlobalAttributes() {
    return [
      {
        types: ["tableCell", "tableHeader"],
        attributes: {
          verticalAlignment: {
            default: "top",
            parseHTML: (element) => {
              return (
                element.getAttribute("data-vertical-alignment") || "top"
              );
            },
            renderHTML: (attributes) => {
              if (
                !attributes.verticalAlignment ||
                attributes.verticalAlignment === "top"
              ) {
                return {};
              }
              return {
                "data-vertical-alignment": attributes.verticalAlignment,
              };
            },
          },
        },
      },
    ];
  },

  addProseMirrorPlugins() {
    return [];
  },
});
